/**
* 钱包
*/
const balance = {

  getPersonalBalance: "/api/getPersonalBalance",//查询个人钱包余额
  getCompanyBalance: "/api/getCompanyBalance",//查询公司钱包余额
  getPersonalBalanceChangingLog: "/api/getPersonalBalanceChangingLog",//查询个人余额变更记录
  getPersonalBalanceChangingLogRecent: "/api/getPersonalBalanceChangingLogRecent",//查询个人近期余额变更记录
  getCompanyBalanceChangingLog: "/api/getCompanyBalanceChangingLog",//查询公司余额变更记录
  getCompanyBalanceChangingLogRecent: "/api/getCompanyBalanceChangingLogRecent",//查询公司近期余额变更记录
  getPersonalBalanceTopUpOrder: "/api/getPersonalBalanceTopUpOrder",//查询个人历史充值订单
  getPersonalBalanceTopUpOrderRecent: "/api/getPersonalBalanceTopUpOrderRecent",//查询个人近期充值订单
  getCompanyBalanceTopUpOrder: "/api/getCompanyBalanceTopUpOrder",//查询公司历史充值订单
  getCompanyBalanceTopUpOrderRecent: "/api/getCompanyBalanceTopUpOrderRecent",//查询公司近期充值订单
  personalBalanceTopUp: "/api/personalBalanceTopUp",//个人充值
  companyBalanceTopUp: "/api/companyBalanceTopUp",//公司充值

  repaymentForBalanceTopUpOrder: "/api/repaymentForBalanceTopUpOrder",//重新支付
  personalWalletIncomeAndExpensesStatisticsMonth: "/api/personalWalletIncomeAndExpensesStatisticsMonth",//个人钱包收支统计
  companyWalletIncomeAndExpensesStatisticsMonth: "/api/companyWalletIncomeAndExpensesStatisticsMonth",//公司钱包收支统计
}

export default balance